// import React, { useState, useEffect, useRef, useContext } from "react";
// import Calendar from "react-calendar";
// import HeaderBar from "../HeaderBar/HeaderBar";
// import "react-calendar/dist/Calendar.css";
// import styles from "./Clender.module.css";
// import FooterNew from "../FooterNew/FooterNew";
// import { useAgentStore } from "../../Store/agentDetailStore";
// import decodeToken from "../../lib/decodeToken";
// import {
//   API_BASE_URL,
//   fetchDashboardDetails,
//   getAgentCallsByMonth,
//   getUserCallsByMonth,
//   getAppointments,
// } from "../../Store/apiStore";
// import axios from "axios";
// import { data, useNavigate } from "react-router-dom";
// import { useCallHistoryStore } from "../../Store/useCallHistoryStore ";
// import { RefreshContext } from "../PreventPullToRefresh/PreventPullToRefresh";

// function formatDateISO(date) {
//   const y = date.getFullYear();
//   const m = String(date.getMonth() + 1).padStart(2, "0");
//   const d = String(date.getDate()).padStart(2, "0");
//   return `${y}-${m}-${d}`;
// }
// // jkds
// function toDateSafe(value) {
//   if (!value && value !== 0) return null;

//   if (value instanceof Date) {
//     return isNaN(value.getTime()) ? null : value;
//   }
//   const asNum = Number(value);
//   if (!Number.isNaN(asNum)) {
//     const ms = asNum < 1e12 ? asNum * 1000 : asNum;
//     const d = new Date(ms);
//     return isNaN(d.getTime()) ? null : d;
//   }

//   const d = new Date(value);
//   return isNaN(d.getTime()) ? null : d;
// }


// function formatStartTime(start, timeZone) {
//   const startDate = toDateSafe(start);
//   if (!startDate) return "—";

//   try {
//     return new Intl.DateTimeFormat("en-US", {
//       hour: "numeric",
//       minute: "2-digit",
//       hour12: true,
//       timeZone: timeZone || "UTC",
//     }).format(startDate);
//   } catch (e) {
//     console.error("Timezone error:", timeZone);
//     return "—";
//   }
// }



// const AgentAnalysis = () => {
//   const [agents, setAgents] = useState([]);
//   const [calApiKey, setCalApiKey] = useState(null);
//   const [bookingDates, setBookingDates] = useState({});
//   const [selectedDate, setSelectedDate] = useState(new Date());
//   const [bookingsForSelectedDate, setBookingsForSelectedDate] = useState([]);
//   const [selectedAgentId, setSelectedAgentId] = useState("");
//   const [apiCallHistory, setapiCallHistory] = useState([]);
//   const bookingsRef = useRef(null);
//   const [hydrated, setHydrated] = useState(false);
//   const isRefreshing = useContext(RefreshContext);

//   const token = localStorage.getItem("token") || "";
//   const decodeTokenData = decodeToken(token);
//   const userId = decodeTokenData?.id || "";
//   // Current agent's data for the shared FooterNew (same "More" menu as
//   // /fast-agent-detail). Populated by the agent screens; safe if null.
//   const { agentData } = useAgentStore();
//   const [selectedAgentEventId, setSelectedAgentEventId] = useState("");
//   const { callHistory, totalCalls, hasFetched, setCallHistoryData } =
//     useCallHistoryStore.getState();

//   useEffect(() => {
//     const unsub = useCallHistoryStore.persist.onFinishHydration(() => {
//       setHydrated(true);
//       fetchCallHistory();
//     });
//     return () => unsub();
//   }, []);

//   useEffect(() => {
//     const foundAgent = agents.find((a) => a.agent_id === selectedAgentId);
//     setSelectedAgentEventId(foundAgent?.eventId || "");
//   }, [selectedAgentId, agents]);

//   const fetchUserAgents = async () => {
//     if (!userId) return;
//     try {
//       const res = await fetchDashboardDetails(userId, token);
//       setAgents(res?.agents);
//     } catch (error) {
//       console.error("Error fetching dashboard data:", error);
//     }
//   };

//   // ── Per-agent appointment permission (multi-owner) ────────────────────────
//   // Agents from the dashboard store carry the member's role + permissions for
//   // that agent's owner. A team member may view an agent's appointments only if
//   // they're an admin for that owner, or that owner granted viewAppointments.
//   // Owners see everything. Un-permitted agents render with a 🔒 and are not
//   // selectable in the dropdown.
//   const isTeamMemberCal = !!localStorage.getItem("teamOwnerId");
//   const canViewAgentAppointments = (a) =>
//     !isTeamMemberCal ||
//     a?.__role === "admin" ||
//     a?.__role === "owner" || // your own agent
//     !!a?.__permissions?.viewAppointments;

//   // Agent ids this member may see data for. Used to filter the "All" view so
//   // an un-permitted agent's calls/appointments never show up in the calendar.
//   const permittedAgentIds = new Set(
//     (agents || [])
//       .filter(canViewAgentAppointments)
//       .map((a) => a.agent_id)
//       .filter(Boolean)
//   );

//   useEffect(() => {
//     const sessionData = sessionStorage.getItem("dashboard-session-storage");
//     if (sessionData) {
//       try {
//         const parsed = JSON.parse(sessionData);
//         const agents = parsed?.state?.agents || [];
//         setAgents(agents);
//         const foundKey = agents.find((a) => a.calApiKey)?.calApiKey;
//         if (foundKey) setCalApiKey(foundKey);
//       } catch (e) {
//         console.error("Failed to parse session storage:", e);
//       }
//     }
//   }, []);

//   const fetchCallHistory = async () => {
//     try {
//       const currentDate = new Date();
//       const month = currentDate.getMonth() + 1;
//       const year = currentDate.getFullYear();

//       if (selectedAgentId === "") {
//         const res = await getUserCallsByMonth(userId, month, year);
//         let allCalls = res.calls || [];
//         // "All" view: a team member only sees calls from agents they're
//         // permitted to view — never an un-permitted agent's data.
//         if (isTeamMemberCal) {
//           allCalls = allCalls.filter((c) => permittedAgentIds.has(c.agent_id));
//         }
//         setCallHistoryData(allCalls);
//         setapiCallHistory(allCalls);
//       } else {
//         const response = await getAgentCallsByMonth(
//           selectedAgentId,
//           month,
//           year
//         );
//         const agentCalls = response.calls || [];
//         setCallHistoryData(agentCalls);
//         setapiCallHistory(agentCalls);
//       }
//     } catch (error) {
//       console.error("Error fetching call history:", error);
//       setCallHistoryData([]);
//       setapiCallHistory([]);
//     }
//   };

//   useEffect(() => {
//     fetchCallHistory();
//   }, [selectedAgentId, agents]);

//   // Builds the map from Calls + Cal.com
//   const fetchBookingDates = async () => {
//     const filteredCalls = selectedAgentId
//       ? callHistory.filter(
//         (call) => String(call.agent_id) === String(selectedAgentId)
//       )
//       : callHistory || apiCallHistory;

//     const bookingsMap = {};

//     // Calls
//     filteredCalls.forEach((call) => {
//       const callDate = formatDateISO(new Date(call.start_timestamp));
//       if (!bookingsMap[callDate]) bookingsMap[callDate] = [];
//       bookingsMap[callDate].push({ ...call, type: "call" });
//     });

//     // Cal.com
//     if (calApiKey) {
//       try {
//         const response = await fetch(
//           `https://api.cal.com/v1/bookings?apiKey=${encodeURIComponent(
//             calApiKey
//           )}`
//         );
//         const bookingsData = await response.json();

//         const selectedAgent = agents.find(
//           (a) => String(a.agent_id) === String(selectedAgentId)
//         );
//         const selectedEventId = selectedAgent?.eventId;

//         bookingsData.bookings?.forEach((booking) => {
//           const date = new Date(booking.startTime);
//           const formattedDate = formatDateISO(date);

//           const match =
//             selectedEventId &&
//             Number(booking.eventTypeId) === Number(selectedEventId);
//           const shouldInclude = !selectedAgentId || match;

//           if (shouldInclude) {
//             if (!bookingsMap[formattedDate]) bookingsMap[formattedDate] = [];

//             const attendeeEmailsFromList = (booking.attendees || [])
//               .map((a) => a?.email)
//               .filter(Boolean);
//             const fallbackEmail =
//               booking?.responses?.email || booking?.user?.email || null;

//             const attendeeEmails =
//               attendeeEmailsFromList.length > 0
//                 ? attendeeEmailsFromList
//                 : fallbackEmail
//                   ? [fallbackEmail]
//                   : [];

//             bookingsMap[formattedDate].push({
//               ...booking,
//               type: "meeting",
//               attendeeEmails,
//             });
//           }
//         });
//       } catch (error) {
//         console.error("Cal.com API fetch failed:", error);
//       }
//     }
//     return bookingsMap;
//   };

//   const fetchDatabaseAppointments = async (baseMap) => {
//     try {
//       const res = await getAppointments(userId, selectedAgentId || null);
//       if (!res?.success) return baseMap;

//       let dbAppointments = res.data || [];
//       // "All" view: drop appointments belonging to agents this team member
//       // isn't permitted to see (per-owner appointment permission).
//       if (isTeamMemberCal) {
//         dbAppointments = dbAppointments.filter((a) =>
//           permittedAgentIds.has(a.agentId)
//         );
//       }
//       const mergedMap = { ...baseMap };

//       dbAppointments.forEach((appt) => {
//         const dateStr = appt.appointmentDate; // e.g., "2025-10-08"
//         if (!mergedMap[dateStr]) mergedMap[dateStr] = [];

//         // Try typical field names; adjust if your API differs
//         const apptTime =
//           appt.startTime ||
//           appt.appointmentTime || // e.g., "14:30"
//           appt.time ||
//           null;

//         // If we have both date & time, build an ISO-like string; else leave null
//         const computedStart =
//           dateStr && apptTime
//             ? `${dateStr}T${apptTime}`
//             : appt.startTime || null;

//         mergedMap[dateStr].push({
//           ...appt,
//           type: "db-appointment",
//           startTime: computedStart,
//           attendeeEmails: appt.attendeeEmail ? [appt.attendeeEmail] : [],
//         });
//       });

//       return mergedMap;
//     } catch (err) {
//       console.error("Error fetching database appointments:", err);
//       return baseMap;
//     }
//   };

//   // Build everything together
//   useEffect(() => {
//     const fetchAllBookings = async () => {
//       const baseMap = await fetchBookingDates();
//       const mergedMap = await fetchDatabaseAppointments(baseMap);

//       setBookingDates(mergedMap);
//       setBookingsForSelectedDate(mergedMap[formatDateISO(selectedDate)] || []);
//     };

//     fetchAllBookings();
//   }, [calApiKey, selectedDate, selectedAgentId, callHistory, agents, hydrated]);

//   const handleDateClick = (date) => {
//     setSelectedDate(date);
//     setBookingsForSelectedDate(bookingDates[formatDateISO(date)] || []);
//     if (bookingsRef.current) {
//       bookingsRef.current.scrollIntoView({
//         behavior: "smooth",
//         block: "start",
//       });
//     }
//   };
//   const navigate = useNavigate();

//   const tileContent = ({ date, view }) => {
//     if (view !== "month") return null;
//     const dateStr = formatDateISO(date);
//     const items = bookingDates[dateStr] || [];

//     const meetingCount = items.filter((i) => i.type === "meeting").length;
//     const dbCount = items.filter((i) => i.type === "db-appointment").length;
//     const callCount = items.filter((i) => i.type === "call" && i.call_type !== "direct_transfer").length;
//     const transferCount = items.filter((i) => i.type === "call" && (i.call_type === "direct_transfer" || i.call_type === "failed_transfer")).length;

//     const totalBookings = meetingCount + dbCount;
//     const formatCount = (count) => (count > 99 ? "99+" : count);

//     return (
//       <div className={styles.bookingDotContainer}>
//         {totalBookings > 0 && (
//           <div className={`${styles.dot} ${styles.greenDot}`}>
//             {formatCount(totalBookings)}
//           </div>
//         )}
//         {callCount > 0 && (
//           <div className={`${styles.dot} ${styles.orangeDot}`}>
//             {formatCount(callCount)}
//           </div>
//         )}
//         {transferCount > 0 && (
//           <div className={`${styles.dot}`} style={{ backgroundColor: "#E65100", color: "#fff", fontSize: 8, minWidth: 14, height: 14, borderRadius: 7, display: "flex", alignItems: "center", justifyContent: "center" }}>
//             {formatCount(transferCount)}
//           </div>
//         )}
//       </div>
//     );
//   };

//   useEffect(() => {
//     if (isRefreshing) {
//       useCallHistoryStore.setState({ hasFetched: false });
//       fetchCallHistory();
//       // rebuilding both maps (calls + cal + db)
//       (async () => {
//         const baseMap = await fetchBookingDates();
//         const mergedMap = await fetchDatabaseAppointments(baseMap);
//         setBookingDates(mergedMap);
//         setBookingsForSelectedDate(
//           mergedMap[formatDateISO(selectedDate)] || []
//         );
//       })();
//     }
//   }, [isRefreshing]);

//   const handleMonthChange = async (month, year) => {
//     try {
//       if (selectedAgentId) {
//         const res = await getAgentCallsByMonth(selectedAgentId, month, year);
//         setCallHistoryData(res.calls || []);
//         setapiCallHistory(res.calls || []);
//       } else {
//         const res = await getUserCallsByMonth(userId, month, year);
//         setCallHistoryData(res.calls || []);
//         setapiCallHistory(res.calls || []);
//       }
//     } catch (error) {
//       console.error("Error fetching month data:", error);
//       setCallHistoryData([]);
//       setapiCallHistory([]);
//     }
//   };

//   return (
//     <div className={styles.container}>
//       <div className={styles.HeaderFlex}>
//         <HeaderBar title="Calendar" backgroundColor="#0000" color="#ffff" />

//         <div className={styles.DateSecT}>
//           {/* {selectedAgentId && <p>Agent</p>} */}

//           <div className={styles.selectedValue}>
//             <select
//               className={styles.agentSelect1}
//               value={selectedAgentId}
//               onChange={(e) => setSelectedAgentId(e.target.value)}
//             >
//               <option value="">All</option>
//               {agents.map((agent) => {
//                 const allowed = canViewAgentAppointments(agent);
//                 const name =
//                   agent.agentName?.length > 10
//                     ? agent.agentName.slice(0, 10) + "..."
//                     : agent.agentName;
//                 return (
//                   <option
//                     key={agent.agent_id}
//                     value={agent.agent_id}
//                     disabled={!allowed}
//                     title={
//                       allowed
//                         ? undefined
//                         : "You don't have appointment access for this agent"
//                     }
//                   >
//                     {allowed ? name : `🔒 ${name}`}
//                   </option>
//                 );
//               })}
//             </select>
//           </div>
//         </div>
//       </div>

//       <div className={styles.calendarSection}>
//         <div className={styles.DotINfo}>
//           <div className={styles.DotOrange}>
//             <div className={styles.dot1}></div>
//             <span>Calls Received</span>
//           </div>
//           <hr />
//           <div className={styles.DotGreen}>
//             <div className={styles.dot}></div>
//             <span>Bookings </span>
//           </div>
//         </div>

//         <Calendar
//           onChange={handleDateClick}
//           value={selectedDate}
//           tileContent={tileContent}
//           onActiveStartDateChange={({ activeStartDate }) => {
//             const m = activeStartDate.getMonth() + 1;
//             const y = activeStartDate.getFullYear();
//             handleMonthChange(m, y);
//           }}
//           calendarType="gregory"
//           className={styles.reactCalendar}
//         />
//       </div>

//       {bookingsForSelectedDate.length > 0 && (
//         <div className={styles.bookingsList} ref={bookingsRef}>
//           <h3>{selectedDate.toDateString()}</h3>
//           <ul>
//             {bookingsForSelectedDate.map((item, index) => {
//               const isMeeting = item.type === "meeting";
//               const isCall = item.type === "call";
//               const isDbAppt = item.type === "db-appointment";

//               // Booking status. Backend reschedule pe status ko "booked" hi rakhta
//               // hai (sirf rescheduleCount badhta hai) — isliye "Rescheduled" us
//               // count se derive hota hai, status se nahi.
//               const apptStatus = String(item.status || "").toLowerCase();
//               const isCancelled = isDbAppt && apptStatus === "cancelled";
//               const isRescheduled =
//                 isDbAppt && !isCancelled && Number(item.rescheduleCount || 0) > 0;

//               const dotColorClass = isCancelled
//                 ? styles.grayBar
//                 : isMeeting
//                   ? styles.greenBar
//                   : isCall
//                     ? styles.orangeBar
//                     : styles.greenBar;
//               const emails =
//                 item.attendeeEmails && item.attendeeEmails.length
//                   ? item.attendeeEmails
//                   : [];
//               return (
//                 <li
//                   key={index}
//                   className={styles.bookingItem}
//                   onClick={() => {
//                     if (isCall && item.call_id) {
//                       navigate(`/call-details/${item.call_id}`, {
//                         state: {
//                           agentId: item.agent_id,
//                           start_timestamp: item.start_timestamp,
//                         },
//                       });
//                     }
//                   }}
//                   style={{ cursor: isCall ? "pointer" : "default" }}
//                 >
//                   <div className={styles.timeColumn}>
//                     <span className={styles.timeLabel}>
//                       {formatStartTime(
//                         item.startTime ?? item.start_timestamp,
//                         item.timezone || item.appointment_timezone
//                       )}
//                     </span>


//                   </div>

//                   <span
//                     className={`${styles.verticalBar} ${dotColorClass}`}
//                   ></span>

//                   <div className={styles.detailColumn}>
//                     <div className={styles.line}>
//                       <span
//                         className={styles.titleText}
//                         style={isCancelled ? { textDecoration: "line-through", opacity: 0.6 } : undefined}
//                       >
//                         <b>{isCall ? "Caller:" : "Title:"}</b>{" "}
//                         {isDbAppt
//                           ? `${item.reason} by ${item.attendeeName}`
//                           : item.title ||
//                           item.custom_analysis_data?.name ||
//                           item.custom_analysis_data?.[
//                           "_detailed _call _summery"
//                           ] ||
//                           "N/A"}
//                       </span>

//                       {/* Cancelled / Rescheduled status — pehle ye kahin dikhta hi
//                           nahi tha, isliye cancel hui booking bilkul normal lagti thi. */}
//                       {(isCancelled || isRescheduled) && (
//                         <span style={{
//                           fontSize: 9, padding: "1px 5px", borderRadius: 4, fontWeight: 600, marginLeft: 6,
//                           background: isCancelled ? "#FFEBEE" : "#FFF4E5",
//                           color: isCancelled ? "#C62828" : "#B26A00",
//                           whiteSpace: "nowrap",
//                         }}>
//                           {isCancelled
//                             ? "Cancelled"
//                             : `Rescheduled${Number(item.rescheduleCount) > 1 ? ` ×${item.rescheduleCount}` : ""}`}
//                         </span>
//                       )}
//                     </div>

//                     {/* Show Email for Cal.com bookings & DB appointments */}
//                     {(isMeeting || isDbAppt) && emails.length > 0 && (
//                       <div className={styles.timeRange}>
//                         <b>Email:</b> {emails.join(", ")}
//                       </div>
//                     )}

//                     {/* Existing phone row for calls */}
//                     {isCall && (
//                       <div className={styles.timeRange}>
//                         <b>Phone:</b>{" "}
//                         {item?.from_number || item?.call_type}
//                         {(item.call_type === "direct_transfer" || item.call_type === "failed_transfer") && (() => {
//                           const isVip = item.contact_tier === "vip" || item.contact_tier === "whitelist";
//                           const label = isVip ? "VIP" : "Contact";
//                           const isSuccess = item.call_type === "direct_transfer";
//                           const name = item.contact_name || item.custom_analysis_data?.name || "";
//                           return (
//                             <span style={{
//                               fontSize: 9, padding: "1px 5px", borderRadius: 4, fontWeight: 600, marginLeft: 6,
//                               background: isSuccess ? "#E8F5E9" : "#FFEBEE",
//                               color: isSuccess ? "#2E7D32" : "#C62828",
//                             }}>
//                               {label} - {isSuccess ? "Transferred" : "Missed Transfer"}
//                             </span>
//                           );
//                         })()}
//                       </div>
//                     )}
//                   </div>
//                 </li>
//               );
//             })}
//           </ul>
//         </div>
//       )}

//       {/* Shared FooterNew — same "More" menu as /fast-agent-detail (replaces
//           the old "Create" button). Test Agent routes to the agent home where
//           the live-call modal lives. Owner-only destructive actions
//           (Delete/Upgrade/Cancel) are intentionally not wired here — they
//           remain on /fast-agent-detail. */}
//       <FooterNew
//         agentData={agentData}
//         onTestCall={() => navigate("/fast-agent-detail")}
//       />
//     </div>
//   );
// };

// export default AgentAnalysis;

import React, { useState, useEffect, useRef, useContext } from "react";
import Calendar from "react-calendar";
import { MdFilterList } from "react-icons/md";
import HeaderBar from "../HeaderBar/HeaderBar";
import "react-calendar/dist/Calendar.css";
import styles from "./Clender.module.css";
import FooterNew from "../FooterNew/FooterNew";
import { useAgentStore } from "../../Store/agentDetailStore";
import decodeToken from "../../lib/decodeToken";
import {
  API_BASE_URL,
  fetchDashboardDetails,
  fetchTeamDashboard,
  getAgentCallsByMonth,
  getUserCallsByMonth,
  getAppointments,
} from "../../Store/apiStore";
import axios from "axios";
import { data, useNavigate, useLocation } from "react-router-dom";
import { useCallHistoryStore } from "../../Store/useCallHistoryStore ";
import { RefreshContext } from "../PreventPullToRefresh/PreventPullToRefresh";
// import DesktopShell from "../DesktopShell/DesktopShell";
// import { buildSidebarItems } from "../DesktopShell/navItems";

function formatDateISO(date) {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}
// jkds
function toDateSafe(value) {
  if (!value && value !== 0) return null;

  if (value instanceof Date) {
    return isNaN(value.getTime()) ? null : value;
  }
  const asNum = Number(value);
  if (!Number.isNaN(asNum)) {
    const ms = asNum < 1e12 ? asNum * 1000 : asNum;
    const d = new Date(ms);
    return isNaN(d.getTime()) ? null : d;
  }

  const d = new Date(value);
  return isNaN(d.getTime()) ? null : d;
}


function formatStartTime(start, timeZone) {
  const startDate = toDateSafe(start);
  if (!startDate) return "—";

  try {
    return new Intl.DateTimeFormat("en-US", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
      timeZone: timeZone || "UTC",
    }).format(startDate);
  } catch (e) {
    console.error("Timezone error:", timeZone);
    return "—";
  }
}



const AgentAnalysis = () => {
  const [agents, setAgents] = useState([]);
  const [calApiKey, setCalApiKey] = useState(null);
  const [bookingDates, setBookingDates] = useState({});
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [bookingsForSelectedDate, setBookingsForSelectedDate] = useState([]);
  // Whether the user has clicked a specific date. When false, the list below
  // shows the WHOLE visible month's calls/bookings; once a date is clicked it
  // narrows to just that day. Reset to false on month navigation.
  const [hasSelectedDate, setHasSelectedDate] = useState(false);
  const [selectedAgentId, setSelectedAgentId] = useState("");
  // Type filter (right side of the selected-date list): "all" | "call" | "booking".
  // "call" = Calls Received; "booking" = Cal.com meetings + DB appointments.
  const [typeFilter, setTypeFilter] = useState("booking");
  // Custom (non-native) filter dropdown open state + ref for click-outside.
  // We avoid a native <select> because its OS menu renders off-box on mobile.
  const [filterOpen, setFilterOpen] = useState(false);
  // Which option is being hovered in the custom dropdown (for hover highlight).
  const [hoveredOpt, setHoveredOpt] = useState(null);
  const filterRef = useRef(null);
  // Agent picker dropdown. Also custom rather than a native <select>: Android
  // renders a <select>'s menu as a centred modal dialog floating over the
  // page instead of a menu anchored under the control.
  const [agentMenuOpen, setAgentMenuOpen] = useState(false);
  const agentRef = useRef(null);
  const [apiCallHistory, setapiCallHistory] = useState([]);
  const bookingsRef = useRef(null);
  // Set true when we arrive via an appointment bell notification
  // (/calendar?date=…&focus=bookings) so we scroll the booking into view once
  // that date's items load.
  const focusBookingsRef = useRef(false);
  const location = useLocation();

  // Deep-link from an appointment notification: open the calendar ON the
  // appointment's date (not today's default) so the booking is visible.
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const dateParam = params.get("date");
    if (!dateParam) return;
    const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(dateParam.trim());
    const parsed = m
      ? new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]))
      : new Date(dateParam);
    if (isNaN(parsed.getTime())) return;
    setSelectedDate(parsed);
    if (params.get("focus") === "bookings") focusBookingsRef.current = true;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search]);

  // Once the target date's items have loaded, scroll the booking into view.
  useEffect(() => {
    if (!focusBookingsRef.current || bookingsForSelectedDate.length === 0) return;
    focusBookingsRef.current = false;
    if (bookingsRef.current) {
      bookingsRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, [bookingsForSelectedDate]);

  // Close the custom filter dropdown when clicking anywhere outside it.
  useEffect(() => {
    if (!filterOpen) return;
    const onDocClick = (e) => {
      if (filterRef.current && !filterRef.current.contains(e.target)) {
        setFilterOpen(false);
      }
    };
    document.addEventListener("mousedown", onDocClick);
    return () => document.removeEventListener("mousedown", onDocClick);
  }, [filterOpen]);

  // Same, for the agent picker.
  useEffect(() => {
    if (!agentMenuOpen) return;
    const onDocClick = (e) => {
      if (agentRef.current && !agentRef.current.contains(e.target)) {
        setAgentMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", onDocClick);
    return () => document.removeEventListener("mousedown", onDocClick);
  }, [agentMenuOpen]);

  const [hydrated, setHydrated] = useState(false);
  const isRefreshing = useContext(RefreshContext);

  const token = localStorage.getItem("token") || "";
  const decodeTokenData = decodeToken(token);
  const userId = decodeTokenData?.id || "";
  // Current agent's data for the shared FooterNew (same "More" menu as
  // /fast-agent-detail). Populated by the agent screens; safe if null.
  const { agentData } = useAgentStore();
  const [selectedAgentEventId, setSelectedAgentEventId] = useState("");
  const { callHistory, totalCalls, hasFetched, setCallHistoryData } =
    useCallHistoryStore.getState();

  useEffect(() => {
    const unsub = useCallHistoryStore.persist.onFinishHydration(() => {
      setHydrated(true);
      fetchCallHistory();
    });
    return () => unsub();
  }, []);

  useEffect(() => {
    const foundAgent = agents.find((a) => a.agent_id === selectedAgentId);
    setSelectedAgentEventId(foundAgent?.eventId || "");
  }, [selectedAgentId, agents]);

  // Returns the list as well as storing it, so the caller can seed calApiKey
  // from the same data without waiting for a re-render.
  //
  // A team member's agents belong to their OWNER, not to them. Asking
  // fetchDashboardDetails for their own id returns the agents they personally
  // own - usually none - so the calendar came up empty however many permissions
  // the owner had granted. fetchTeamDashboard is the team-aware path: it walks
  // every owner the member belongs to and stamps each agent with the __role and
  // __permissions that canViewAgentAppointments below already reads. Those two
  // fields are set nowhere else, which is what makes this the intended source.
  const fetchUserAgents = async () => {
    if (isTeamMemberCal) {
      try {
        const res = await fetchTeamDashboard();
        const list = res?.agents || [];
        setAgents(list);
        return list;
      } catch (error) {
        console.error("Error fetching team dashboard:", error);
        return [];
      }
    }
    if (!userId) return [];
    try {
      const res = await fetchDashboardDetails(userId, token);
      // `|| []` matters: setAgents(undefined) would blow up the
      // `agents.find(...)` in the selectedAgentEventId effect below.
      const list = res?.agents || [];
      setAgents(list);
      return list;
    } catch (error) {
      console.error("Error fetching dashboard data:", error);
      return [];
    }
  };

  // ── Per-agent appointment permission (multi-owner) ────────────────────────
  // Agents from the dashboard store carry the member's role + permissions for
  // that agent's owner. A team member may view an agent's appointments only if
  // they're an admin for that owner, or that owner granted viewAppointments.
  // Owners see everything. Un-permitted agents render with a 🔒 and are not
  // selectable in the dropdown.
  const isTeamMemberCal = !!localStorage.getItem("teamOwnerId");
  const canViewAgentAppointments = (a) =>
    !isTeamMemberCal ||
    a?.__role === "admin" ||
    a?.__role === "owner" || // your own agent
    !!a?.__permissions?.viewAppointments;

  // Agentt ids this member may see data for. Used to filter the "All" view so
  // an un-permitted agent's calls/appointments never show up in the calendar.
  const permittedAgentIds = new Set(
    (agents || [])
      .filter(canViewAgentAppointments)
      .map((a) => a.agent_id)
      .filter(Boolean)
  );

  /*
   * Seed the agent list.
   *
   * The dashboard's session cache used to be the ONLY thing that ever filled
   * `agents` — fetchUserAgents was defined but never called. So reaching
   * /calendar without the Dashboard having populated that cache (deep link,
   * hard reload, a fresh tab, cleared session storage) left the list empty,
   * and the agent picker fell through to "All" with an empty menu even for a
   * single-agent account. Fall back to the API when the cache can't answer.
   */
  useEffect(() => {
    let cancelled = false;

    let cached = [];
    try {
      const sessionData = sessionStorage.getItem("dashboard-session-storage");
      cached = sessionData ? JSON.parse(sessionData)?.state?.agents || [] : [];
    } catch (e) {
      console.error("Failed to parse session storage:", e);
    }

    const seedCalKey = (list) => {
      const foundKey = list.find((a) => a.calApiKey)?.calApiKey;
      if (foundKey) setCalApiKey(foundKey);
    };

    if (cached.length) {
      setAgents(cached);
      seedCalKey(cached);
      return;
    }

    (async () => {
      const list = await fetchUserAgents();
      if (!cancelled && list.length) seedCalKey(list);
    })();

    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId]);

  /*
   * Calls for one month across every agent the viewer may see.
   *
   * An owner gets them in one request: the by-user endpoint answers "calls for
   * agents this user OWNS". A team member owns none of them - the agents belong
   * to whoever added them - so that same request comes back empty however many
   * permissions they hold, which is why the calendar showed nothing. Their
   * permitted agents can also span several owners, so no single user id would
   * cover them either. Asking per agent is the question that actually applies,
   * and it needs no filtering afterwards: an un-permitted agent is never asked
   * about in the first place.
   */
  const fetchAllAgentsCalls = async (month, year) => {
    if (!isTeamMemberCal) {
      const res = await getUserCallsByMonth(userId, month, year);
      return res?.calls || [];
    }
    const results = await Promise.all(
      [...permittedAgentIds].map((id) =>
        getAgentCallsByMonth(id, month, year).catch((e) => {
          console.error("Calendar: calls fetch failed for", id, e?.message);
          return null;
        })
      )
    );
    return results.flatMap((r) => r?.calls || []);
  };

  const fetchCallHistory = async () => {
    try {
      const currentDate = new Date();
      const month = currentDate.getMonth() + 1;
      const year = currentDate.getFullYear();

      if (selectedAgentId === "") {
        const allCalls = await fetchAllAgentsCalls(month, year);
        setCallHistoryData(allCalls);
        setapiCallHistory(allCalls);
      } else {
        const response = await getAgentCallsByMonth(
          selectedAgentId,
          month,
          year
        );
        const agentCalls = response.calls || [];
        setCallHistoryData(agentCalls);
        setapiCallHistory(agentCalls);
      }
    } catch (error) {
      console.error("Error fetching call history:", error);
      setCallHistoryData([]);
      setapiCallHistory([]);
    }
  };

  useEffect(() => {
    fetchCallHistory();
  }, [selectedAgentId, agents]);

  // Builds the map from Calls + Cal.com
  const fetchBookingDates = async () => {
    const filteredCalls = selectedAgentId
      ? callHistory.filter(
        (call) => String(call.agent_id) === String(selectedAgentId)
      )
      : callHistory || apiCallHistory;

    const bookingsMap = {};

    // Calls
    filteredCalls.forEach((call) => {
      const callDate = formatDateISO(new Date(call.start_timestamp));
      if (!bookingsMap[callDate]) bookingsMap[callDate] = [];
      bookingsMap[callDate].push({ ...call, type: "call" });
    });

    // Cal.com
    if (calApiKey) {
      try {
        const response = await fetch(
          `https://api.cal.com/v1/bookings?apiKey=${encodeURIComponent(
            calApiKey
          )}`
        );
        const bookingsData = await response.json();

        const selectedAgent = agents.find(
          (a) => String(a.agent_id) === String(selectedAgentId)
        );
        const selectedEventId = selectedAgent?.eventId;

        bookingsData.bookings?.forEach((booking) => {
          const date = new Date(booking.startTime);
          const formattedDate = formatDateISO(date);

          const match =
            selectedEventId &&
            Number(booking.eventTypeId) === Number(selectedEventId);
          const shouldInclude = !selectedAgentId || match;

          if (shouldInclude) {
            if (!bookingsMap[formattedDate]) bookingsMap[formattedDate] = [];

            const attendeeEmailsFromList = (booking.attendees || [])
              .map((a) => a?.email)
              .filter(Boolean);
            const fallbackEmail =
              booking?.responses?.email || booking?.user?.email || null;

            const attendeeEmails =
              attendeeEmailsFromList.length > 0
                ? attendeeEmailsFromList
                : fallbackEmail
                  ? [fallbackEmail]
                  : [];

            bookingsMap[formattedDate].push({
              ...booking,
              type: "meeting",
              attendeeEmails,
            });
          }
        });
      } catch (error) {
        console.error("Cal.com API fetch failed:", error);
      }
    }
    return bookingsMap;
  };

  const fetchDatabaseAppointments = async (baseMap) => {
    try {
      let dbAppointments = [];

      if (isTeamMemberCal && !selectedAgentId) {
        // Same reasoning as the calls above: appointments are looked up by the
        // owning user, so a member's own id matches nothing, and their agents
        // may belong to more than one owner. The endpoint accepts an agentId on
        // its own, so ask per permitted agent and merge.
        const results = await Promise.all(
          [...permittedAgentIds].map((id) =>
            getAppointments(null, id).catch((e) => {
              console.error("Calendar: appointments fetch failed for", id, e?.message);
              return null;
            })
          )
        );
        dbAppointments = results.flatMap((r) => (r?.success ? r.data || [] : []));
      } else {
        const res = await getAppointments(userId, selectedAgentId || null);
        if (!res?.success) return baseMap;
        dbAppointments = res.data || [];
        // One agent is selected: confirm the member may actually see it.
        if (isTeamMemberCal) {
          dbAppointments = dbAppointments.filter((a) =>
            permittedAgentIds.has(a.agentId)
          );
        }
      }
      const mergedMap = { ...baseMap };

      dbAppointments.forEach((appt) => {
        const dateStr = appt.appointmentDate; // e.g., "2025-10-08"
        if (!mergedMap[dateStr]) mergedMap[dateStr] = [];

        // Try typical field names; adjust if your API differs
        const apptTime =
          appt.startTime ||
          appt.appointmentTime || // e.g., "14:30"
          appt.time ||
          null;

        // If we have both date & time, build an ISO-like string; else leave null
        const computedStart =
          dateStr && apptTime
            ? `${dateStr}T${apptTime}`
            : appt.startTime || null;

        mergedMap[dateStr].push({
          ...appt,
          type: "db-appointment",
          startTime: computedStart,
          attendeeEmails: appt.attendeeEmail ? [appt.attendeeEmail] : [],
        });
      });

      return mergedMap;
    } catch (err) {
      console.error("Error fetching database appointments:", err);
      return baseMap;
    }
  };

  // Build everything together
  useEffect(() => {
    const fetchAllBookings = async () => {
      const baseMap = await fetchBookingDates();
      const mergedMap = await fetchDatabaseAppointments(baseMap);

      setBookingDates(mergedMap);
      setBookingsForSelectedDate(mergedMap[formatDateISO(selectedDate)] || []);
    };

    fetchAllBookings();
  }, [calApiKey, selectedDate, selectedAgentId, callHistory, agents, hydrated]);

  /*
   * Desktop flag. Used only to keep the right-hand card rendered when the
   * selected date is empty — the calendar always opens on TODAY, on every
   * viewport. (An earlier version auto-jumped to the most recent date that had
   * activity; that was reverted because showing the 3rd's calls while today is
   * the 4th reads as wrong data rather than a helpful shortcut.)
   */
  const [isDeskCal, setIsDeskCal] = useState(
    typeof window !== "undefined" &&
      window.matchMedia("(min-width: 992px)").matches
  );
  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) return;
    const mq = window.matchMedia("(min-width: 992px)");
    const update = () => setIsDeskCal(mq.matches);
    update();
    mq.addEventListener("change", update);
    return () => mq.removeEventListener("change", update);
  }, []);

  /* Desktop panel header: date with a calendar chip on the left, the event-type
     filter on the right — shares the same `typeFilter` as the mobile pill, so
     both stay in sync. Mobile keeps the plain <h3> that follows it. */
  const deskListHeadEl = isDeskCal ? (
    <div className={styles.deskListHead}>
      <div className={styles.deskListDate}>
        <span className={styles.deskListDateIcon} aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="currentColor">
            <path d="M7 2v2h10V2h2v2h1.5A1.5 1.5 0 0 1 22 5.5v15a1.5 1.5 0 0 1-1.5 1.5h-17A1.5 1.5 0 0 1 2 20.5v-15A1.5 1.5 0 0 1 3.5 4H5V2h2ZM4 10v10h16V10H4Zm2.5 2h3v3h-3v-3Z" />
          </svg>
        </span>
        <span>{selectedDate.toDateString()}</span>
      </div>

      <label className={styles.deskEventFilter}>
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          aria-hidden="true"
        >
          <path d="M4 6h16M7 12h10M10 18h4" />
        </svg>
        <select
          value={typeFilter}
          onChange={(e) => setTypeFilter(e.target.value)}
          aria-label="Filter events"
        >
          <option value="all">All Events</option>
          <option value="booking">Meetings Booked</option>
          <option value="call">Calls Received</option>
        </select>
      </label>
    </div>
  ) : null;

  const handleDateClick = (date) => {
    setSelectedDate(date);
    setHasSelectedDate(true);
    setBookingsForSelectedDate(bookingDates[formatDateISO(date)] || []);
    if (bookingsRef.current) {
      bookingsRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };
  const navigate = useNavigate();

  const tileContent = ({ date, view }) => {
    if (view !== "month") return null;
    const dateStr = formatDateISO(date);
    const items = bookingDates[dateStr] || [];

    const meetingCount = items.filter((i) => i.type === "meeting").length;
    const dbCount = items.filter((i) => i.type === "db-appointment").length;
    const callCount = items.filter((i) => i.type === "call" && i.call_type !== "direct_transfer").length;
    const transferCount = items.filter((i) => i.type === "call" && (i.call_type === "direct_transfer" || i.call_type === "failed_transfer")).length;

    const totalBookings = meetingCount + dbCount;
    const formatCount = (count) => (count > 99 ? "99+" : count);

    // Respect the type filter: booking-only hides call/transfer dots,
    // call-only hides the green booking dot.
    const showBookings = typeFilter === "all" || typeFilter === "booking";
    const showCalls = typeFilter === "all" || typeFilter === "call";

    return (
      <div className={styles.bookingDotContainer}>
        {showBookings && totalBookings > 0 && (
          <div className={`${styles.dot} ${styles.greenDot}`}>
            {formatCount(totalBookings)}
          </div>
        )}
        {showCalls && callCount > 0 && (
          <div className={`${styles.dot} ${styles.orangeDot}`}>
            {formatCount(callCount)}
          </div>
        )}
        {showCalls && transferCount > 0 && (
          <div className={`${styles.dot}`} style={{ backgroundColor: "#E65100", color: "#fff", fontSize: 8, minWidth: 14, height: 14, borderRadius: 7, display: "flex", alignItems: "center", justifyContent: "center" }}>
            {formatCount(transferCount)}
          </div>
        )}
      </div>
    );
  };

  useEffect(() => {
    if (isRefreshing) {
      useCallHistoryStore.setState({ hasFetched: false });
      fetchCallHistory();
      // rebuilding both maps (calls + cal + db)
      (async () => {
        const baseMap = await fetchBookingDates();
        const mergedMap = await fetchDatabaseAppointments(baseMap);
        setBookingDates(mergedMap);
        setBookingsForSelectedDate(
          mergedMap[formatDateISO(selectedDate)] || []
        );
      })();
    }
  }, [isRefreshing]);

  const handleMonthChange = async (month, year) => {
    // Navigating months resets to the "whole month" view (no specific day picked).
    setHasSelectedDate(false);
    try {
      if (selectedAgentId) {
        const res = await getAgentCallsByMonth(selectedAgentId, month, year);
        setCallHistoryData(res.calls || []);
        setapiCallHistory(res.calls || []);
      } else {
        // Same team-member problem as the initial load, so the same helper.
        const calls = await fetchAllAgentsCalls(month, year);
        setCallHistoryData(calls);
        setapiCallHistory(calls);
      }
    } catch (error) {
      console.error("Error fetching month data:", error);
      setCallHistoryData([]);
      setapiCallHistory([]);
    }
  };

  // Time used to sort list rows (calls use start_timestamp, bookings use startTime).
  const itemTime = (item) => {
    const d = toDateSafe(item.startTime ?? item.start_timestamp);
    return d ? d.getTime() : 0;
  };

  // What the list below the calendar shows:
  //  - no date clicked  → the WHOLE visible month (all days flattened)
  //  - a date clicked   → just that day's items
  // Both are sorted newest-first. The month view used to be oldest-first, and
  // the day view was not sorted at all — it came through in insertion order
  // (calls, then Cal.com bookings, then DB appointments).
  const displayedItems = (
    hasSelectedDate
      ? [...bookingsForSelectedDate]
      : Object.values(bookingDates || {}).flat()
  ).sort((a, b) => itemTime(b) - itemTime(a));

  // Apply the call/booking/all type filter to whatever is displayed.
  const filteredItems = displayedItems.filter((item) => {
    if (typeFilter === "call") return item.type === "call";
    if (typeFilter === "booking")
      return item.type === "meeting" || item.type === "db-appointment";
    return true;
  });

  const agentOptions = (agents || []).filter((a) => a?.agent_id);
  const agentLabel = (a) =>
    a?.agentName?.length > 10
      ? a.agentName.slice(0, 10) + "..."
      : a?.agentName || "";
  // With exactly one agent, "All" IS that agent — so show its name instead of
  // a choice the user can't meaningfully make. selectedAgentId deliberately
  // stays "" (the all-agents data path): selecting the agent id would switch
  // the Cal.com branch in fetchBookingDates to eventId matching and drop
  // bookings for an agent that has no eventId.
  const singleAgent = agentOptions.length === 1 ? agentOptions[0] : null;
  const selectedAgent = agentOptions.find(
    (a) => String(a.agent_id) === String(selectedAgentId)
  );
  const agentTriggerText = singleAgent
    ? agentLabel(singleAgent)
    : selectedAgent
      ? agentLabel(selectedAgent)
      : "All";

  // Agent picker used by the DesktopShell return below (as both the header
  // `actions` and inside the mobile HeaderFlex). Extracted here so it can be
  // referenced in two places without duplicating the markup.
  const agentPicker = (
    <div
      ref={agentRef}
      className={`${styles.DateSecT} ${singleAgent ? styles.noCaret : ""}`}
    >
      <p className={styles.deskAgentLabel}>Agent</p>

      {/* The value sits directly on the .DateSecT pill — no inner bordered
          box, so the picker reads the same whether or not it opens a menu. */}
      {singleAgent ? (
        <span className={styles.agentSelect1} title={singleAgent.agentName}>
          {agentTriggerText}
        </span>
      ) : (
        <>
          <div
            style={{ cursor: "pointer", userSelect: "none" }}
            onClick={() => setAgentMenuOpen((v) => !v)}
          >
            <span className={styles.agentSelect1}>{agentTriggerText}</span>
          </div>

          {agentMenuOpen && (
            <div className={styles.agentMenu}>
              {[{ agent_id: "", __all: true }, ...agentOptions].map((agent) => {
                const allowed = agent.__all || canViewAgentAppointments(agent);
                const active =
                  String(selectedAgentId) === String(agent.agent_id);
                const name = agent.__all ? "All" : agentLabel(agent);
                return (
                  <div
                    key={agent.agent_id || "all"}
                    className={`${styles.agentMenuItem} ${
                      active ? styles.agentMenuItemActive : ""
                    }`}
                    style={
                      allowed ? undefined : { opacity: 0.5, cursor: "not-allowed" }
                    }
                    title={
                      allowed
                        ? undefined
                        : "You don't have appointment access for this agent"
                    }
                    onClick={() => {
                      if (!allowed) return;
                      setSelectedAgentId(agent.agent_id);
                      setAgentMenuOpen(false);
                    }}
                  >
                    {allowed ? name : `🔒 ${name}`}
                  </div>
                );
              })}
            </div>
          )}
        </>
      )}
    </div>
  );

  return (
    /* DesktopShell renders nothing below 992px, so mobile is unchanged. */
    // <DesktopShell
    //   sidebarItems={buildSidebarItems({
    //     navigate,
    //     agentData,
    //     activeKey: "calendar",
    //   })}
    //   title="Calendar"
    //   subtitle="View your calls and booked meetings in one place."
    //   actions={agentPicker}
    // >
    <div className={styles.container}>
      <div className={styles.HeaderFlex}>
        <HeaderBar title="Calendar" backgroundColor="#0000" color="#ffffff" />

        {agentPicker}
      </div>

      <div className={styles.calendarSection}>
        <div className={styles.DotINfo}>
          <div className={styles.DotOrange}>
            <div className={styles.dot1}></div>
            <span>Calls Received</span>
          </div>
          <hr />
          <div className={styles.DotGreen}>
            <div className={styles.dot}></div>
            <span>Bookings </span>
          </div>
        </div>

        <Calendar
          onChange={handleDateClick}
          value={selectedDate}
          tileContent={tileContent}
          onActiveStartDateChange={({ activeStartDate }) => {
            const m = activeStartDate.getMonth() + 1;
            const y = activeStartDate.getFullYear();
            handleMonthChange(m, y);
          }}
          calendarType="gregory"
          className={styles.reactCalendar}
        />
      </div>

      {/* Always render this section so the filter is ALWAYS visible — even when
          the day/month has no calls or bookings (then we show a "No data" note
          below instead of hiding everything). */}
      {(
        <div className={styles.bookingsList} ref={bookingsRef}>
          {/* Desktop uses Anubhav's date-chip + filter header; mobile uses the
              pill header below. Both drive the same typeFilter. */}
          {isDeskCal && deskListHeadEl}
          <div
            style={{
              display: isDeskCal ? "none" : "flex",
              justifyContent: "space-between",
              alignItems: "center",
              gap: 10,
            }}
          >
            <h3 style={{ margin: 0 }}>
              {hasSelectedDate
                ? selectedDate.toDateString()
                : selectedDate.toLocaleDateString("en-US", {
                    month: "long",
                    year: "numeric",
                  })}
            </h3>
            {/* Type filter — a custom (non-native) dropdown so its menu is
                themed and stays inside the layout on mobile (the native <select>
                menu rendered off-box). Filters this list + the calendar dots. */}
            <div
              ref={filterRef}
              style={{ position: "relative", marginLeft: "auto", flex: "0 0 auto" }}
            >
              <div
                onClick={() => setFilterOpen((v) => !v)}
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 14,
                  background: "#EEE6FF",
                  borderRadius: 7,
                  padding: "7px 12px",
                  cursor: "pointer",
                  userSelect: "none",
                  width: 160,
                  boxSizing: "border-box",
                }}
              >
                <MdFilterList size={15} color="#5F33E1" style={{ flexShrink: 0 }} />
                <span
                  style={{
                    color: "#5F33E1",
                    fontSize: 16,
                    fontWeight: 600,
                    lineHeight: 1.2,
                    whiteSpace: "nowrap",
                    marginLeft: 0,
                    textAlign: "left",
                  }}
                >
                  {typeFilter === "call"
                    ? "Calls Received"
                    : typeFilter === "booking"
                    ? "Bookings"
                    : "All"}
                </span>
              </div>

              {filterOpen && (
                <div
                  style={{
                    position: "absolute",
                    top: "calc(100% + 4px)",
                    right: 0,
                    width: 160,
                    background: "#fff",
                    border: "1px solid #E6DBFF",
                    borderRadius: 8,
                    boxShadow: "0 6px 20px rgba(101,36,235,0.15)",
                    overflow: "hidden",
                    // Must clear FooterNew's fixed navbar (z-index 50), which
                    // was covering the third option ("Bookings").
                    zIndex: 60,
                  }}
                >
                  {[
                    { value: "all", label: "All" },
                    { value: "call", label: "Calls Received" },
                    { value: "booking", label: "Bookings" },
                  ].map((opt) => {
                    const active = typeFilter === opt.value;
                    const hovered = hoveredOpt === opt.value;
                    return (
                      <div
                        key={opt.value}
                        onClick={() => {
                          setTypeFilter(opt.value);
                          setFilterOpen(false);
                        }}
                        onMouseEnter={() => setHoveredOpt(opt.value)}
                        onMouseLeave={() => setHoveredOpt(null)}
                        style={{
                          padding: "9px 14px",
                          fontSize: 15,
                          fontWeight: active ? 700 : 500,
                          // Selected = solid purple. Hover (not selected) = light
                          // purple tint. Selection only changes on click.
                          color: active ? "#fff" : "#5F33E1",
                          background: active
                            ? "#6524EB"
                            : hovered
                              ? "#F1EAFF"
                              : "transparent",
                          cursor: "pointer",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {opt.label}
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          </div>

          {/* No matching data for the current filter/date — show a centered
              note (the filter above stays visible so the user can switch). */}
          {filteredItems.length === 0 && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "40px 16px",
                color: "#9A9AA7",
                textAlign: "center",
                fontSize: 15,
                fontWeight: 500,
              }}
            >
              No data
            </div>
          )}

          <ul>
            {filteredItems.map((item, index) => {
              const isMeeting = item.type === "meeting";
              const isCall = item.type === "call";
              const isDbAppt = item.type === "db-appointment";

              // Booking status. Backend reschedule pe status ko "booked" hi rakhta
              // hai (sirf rescheduleCount badhta hai) — isliye "Rescheduled" us
              // count se derive hota hai, status se nahi.
              const apptStatus = String(item.status || "").toLowerCase();
              const isCancelled = isDbAppt && apptStatus === "cancelled";
              const isRescheduled =
                isDbAppt && !isCancelled && Number(item.rescheduleCount || 0) > 0;

              const dotColorClass = isCancelled
                ? styles.grayBar
                : isMeeting
                  ? styles.greenBar
                  : isCall
                    ? styles.orangeBar
                    : styles.greenBar;
              const emails =
                item.attendeeEmails && item.attendeeEmails.length
                  ? item.attendeeEmails
                  : [];
              return (
                <li
                  key={index}
                  className={styles.bookingItem}
                  onClick={() => {
                    if (isCall && item.call_id) {
                      navigate(`/call-details/${item.call_id}`, {
                        state: {
                          agentId: item.agent_id,
                          start_timestamp: item.start_timestamp,
                        },
                      });
                    }
                  }}
                  style={{ cursor: isCall ? "pointer" : "default" }}
                >
                  <div className={styles.timeColumn}>
                    <span className={styles.timeLabel}>
                      {formatStartTime(
                        item.startTime ?? item.start_timestamp,
                        item.timezone || item.appointment_timezone
                      )}
                    </span>

                    {/* In the whole-month view rows span many days, so show the
                        date under the time. Hidden once a single day is picked. */}
                    {!hasSelectedDate &&
                      (() => {
                        const d = toDateSafe(
                          item.startTime ?? item.start_timestamp
                        );
                        return d ? (
                          <span
                            style={{
                              display: "block",
                              fontSize: 11,
                              color: "#999",
                              fontWeight: 400,
                            }}
                          >
                            {d.toLocaleDateString("en-US", {
                              month: "short",
                              day: "numeric",
                            })}
                          </span>
                        ) : null;
                      })()}
                  </div>

                  <span
                    className={`${styles.verticalBar} ${dotColorClass}`}
                  ></span>

                  <div className={styles.detailColumn}>
                    <div className={styles.line}>
                      <span
                        className={styles.titleText}
                        style={isCancelled ? { textDecoration: "line-through", opacity: 0.6 } : undefined}
                      >
                        <b>{isCall ? "Caller:" : "Title:"}</b>{" "}
                        {isDbAppt
                          ? `${item.reason} by ${item.attendeeName}`
                          : item.title ||
                          item.custom_analysis_data?.name ||
                          item.custom_analysis_data?.[
                          "_detailed _call _summery"
                          ] ||
                          "N/A"}
                      </span>

                      {/* Cancelled / Rescheduled status — pehle ye kahin dikhta hi
                          nahi tha, isliye cancel hui booking bilkul normal lagti thi. */}
                      {(isCancelled || isRescheduled) && (
                        <span style={{
                          fontSize: 9, padding: "1px 5px", borderRadius: 4, fontWeight: 600, marginLeft: 6,
                          background: isCancelled ? "#FFEBEE" : "#FFF4E5",
                          color: isCancelled ? "#C62828" : "#B26A00",
                          whiteSpace: "nowrap",
                        }}>
                          {isCancelled
                            ? "Cancelled"
                            : `Rescheduled${Number(item.rescheduleCount) > 1 ? ` ×${item.rescheduleCount}` : ""}`}
                        </span>
                      )}

                      {/* Event-type tag — desktop only, so the mobile row keeps
                          its existing single-line layout. */}
                      {isDeskCal && (
                        <span
                          className={`${styles.deskTag} ${isCall ? styles.deskTagCall : styles.deskTagMeeting
                            }`}
                        >
                          <span className={styles.deskTagDot} />
                          {isCall ? "Call Received" : "Meeting Booked"}
                        </span>
                      )}
                    </div>

                    {/* Show Email for Cal.com bookings & DB appointments */}
                    {(isMeeting || isDbAppt) && emails.length > 0 && (
                      <div className={styles.timeRange}>
                        <b>Email:</b> {emails.join(", ")}
                      </div>
                    )}

                    {/* Existing phone row for calls */}
                    {isCall && (
                      <div className={styles.timeRange}>
                        <b>Phone:</b>{" "}
                        {item?.from_number || item?.call_type}
                        {(item.call_type === "direct_transfer" || item.call_type === "failed_transfer") && (() => {
                          const isVip = item.contact_tier === "vip" || item.contact_tier === "whitelist";
                          const label = isVip ? "VIP" : "Contact";
                          const isSuccess = item.call_type === "direct_transfer";
                          const name = item.contact_name || item.custom_analysis_data?.name || "";
                          return (
                            <span style={{
                              fontSize: 9, padding: "1px 5px", borderRadius: 4, fontWeight: 600, marginLeft: 6,
                              background: isSuccess ? "#E8F5E9" : "#FFEBEE",
                              color: isSuccess ? "#2E7D32" : "#C62828",
                            }}>
                              {label} - {isSuccess ? "Transferred" : "Missed Transfer"}
                            </span>
                          );
                        })()}
                      </div>
                    )}
                  </div>
                </li>
              );
            })}
          </ul>
        </div>
      )}

      {/* Shared FooterNew — same "More" menu as /fast-agent-detail (replaces
          the old "Create" button). Test Agent routes to the agent home where
          the live-call modal lives. Owner-only destructive actions
          (Delete/Upgrade/Cancel) are intentionally not wired here — they
          remain on /fast-agent-detail. */}
      <FooterNew
        agentData={agentData}
        onTestCall={() => navigate("/fast-agent-detail")}
      />
    </div>
     /* </DesktopShell>  */
  );
};

export default AgentAnalysis;